export const awsRegion: string = process.env.NX_AWS_REGION ?? '';
export const clientId: string = process.env.NX_COGNITO_CLIENT_ID ?? '';
export const clientSecret: string = process.env.NX_COGNITO_CLIENT_SECRET ?? '';
